module.exports = __webpack_public_path__ + "static/media/phone-booking-refresh.5357f4a5.svg";